import HomeScreen from "../HomeScreen/HomeScreen";
import ClassplusLogo from "../../assets/Images/classplus-logo.png";
import { AndroidScreen } from "../../components/AndroidScreen";
import { useState, useEffect } from "react";
import SouravDadaImage from "../../assets/Images/sourav-dada.png";
import messageEdit from "../../assets/Images/message-edit.svg";
import playCircle from "../../assets/Images/play-cricle.svg";
import announce from "../../assets/Images/Announce.svg";
import name from "../../assets/Images/name.svg";
import './Style.css';

const DesktopScreen = () => {
  const [numberSubmitted, setNumberSubmitted] = useState(false);
  const [instituteName, setInstituteName] = useState("");
  const [headingText, setHeadingText] = useState("Teacherpreneur")
  const headingTexts = ["Teacherpreneur", "Solopreneur", "Videopreneur", "Contentpreneur"];

  useEffect(() => {
    let index = 0
    const interval = setInterval(() => {
      if (index < headingTexts.length - 1) {
        setHeadingText(headingTexts[index + 1]);
        index++
      } else {
        index = 0
        setHeadingText(headingTexts[index]);
      }
    }, 2000)

    return (() => {
      clearInterval(interval);
    })

  }, [])
  return (
    <>
      <div className="desktopScreen mt-10 px-20">
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="fixed w-1/3">
              <img width={200} src={ClassplusLogo} alt="classplus-logo" />
              <h2 className="text-4xl mt-6 text-colorHeading font-semibold">
                {instituteName ? (
                  `Hi, ${instituteName}`
                ) : (
                  <>
                    {/* <span className="border-b-4  border-colorWhite">
                      Create
                    </span>{" "}
                    your Online <br /> presence with Classplus. */}
                    Are you ready to be a <br />
                    <span className="text-colorWhite border-b-2 border-colorHeading ">
                      {headingText}?
                    </span>
                  </>
                )}
              </h2>
              {numberSubmitted ? (
                <div className="w-2/3 mt-10 desktopViewAndroid">
                  <AndroidScreen
                    desktopView={true}
                    userInputs={{}}
                    instituteName={instituteName}
                  />
                </div>
              ) : (
                <>
                  <p className="mt-8">
                    <span className="text-2xl">
                      Kickstart Your Growth Journey
                    </span>
                  </p>
                  <div className="featureContainer">
                    <span className="textStyle"><img src={messageEdit} className="imgStyle"/> Live Classes</span>
                    <span className="textStyle"><img src={playCircle} className="imgStyle"/> Sell Courses</span>
                    <span className="textStyle"><img src={announce} className="imgStyle"/> Manage Coaching</span>
                  </div>
       
                 
   
                   
                </>
              )}
            </div>

            <div className="fixed w-1/4 imgContainerNew">
              <img src={SouravDadaImage} alt="sourav-dada" />
            </div>
          </div>
          <div className="p-4">
            <HomeScreen
              desktopView={true}
              setNumberSubmitted={setNumberSubmitted}
              setInstituteName={setInstituteName}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopScreen;
